import type { DatasetZoomModalHeaderProps } from "./dataset-zoom-modal-header.type";

import "./dataset-zoom-modal-header.style.less";
import { Typography } from "antd";

const { Text } = Typography;

const DatasetZoomModalHeader = ({
  title,
  actions,
}: DatasetZoomModalHeaderProps) => {
  return (
    <div className="dataset-zoom-modal-header">
      <Text ellipsis className="dataset-zoom-modal-header-title">
        {title}
      </Text>
      {actions}
    </div>
  );
};

export default DatasetZoomModalHeader;
